module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.remarks.title_remark_editor')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "multiple": "",
      "disabled": _vm.mode === _vm.MODE_EDIT || _vm.mode === _vm.MODE_NEW
    }
  }, _vm._l((_vm.remarkList), function(rt) {
    return _c('option', {
      key: rt.name,
      on: {
        "click": function($event) {
          _vm.remarkClick(rt)
        }
      }
    }, [_vm._v(_vm._s(rt.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.remarks.name'),
      "disabled": _vm.mode === _vm.MODE_NORMAL
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.$t('message.remarks.remark'),
      "disabled": _vm.mode === _vm.MODE_NORMAL
    },
    model: {
      value: (_vm.remarkText),
      callback: function($$v) {
        _vm.remarkText = $$v
      },
      expression: "remarkText"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-close btn-lg btn-space",
    on: {
      "click": _vm.closeEditor
    }
  }, [_vm._v(_vm._s(this.$t('action_message.close')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg btn-space",
    on: {
      "click": _vm.saveEditor
    }
  }, [_vm._v(_vm._s(this.$t('action_message.save')))]), _vm._v(" "), (_vm.mode === _vm.MODE_EDIT || _vm.mode === _vm.MODE_NEW) ? _c('button', {
    staticClass: "btn btn-cancel btn-lg float-right btn-space",
    on: {
      "click": _vm.cancelMode
    }
  }, [_vm._v(_vm._s(this.$t('action_message.cancel')))]) : _vm._e(), _vm._v(" "), (_vm.mode === _vm.MODE_EDIT || _vm.mode === _vm.MODE_NEW) ? _c('button', {
    staticClass: "btn btn-store btn-lg float-right btn-space",
    on: {
      "click": _vm.saveRemarks
    }
  }, [_vm._v(_vm._s(this.$t('action_message.ok')))]) : _vm._e(), _vm._v(" "), (_vm.mode === _vm.MODE_NORMAL && _vm.remarkObj !== null) ? _c('button', {
    staticClass: "btn btn-delete btn-lg float-right btn-space",
    on: {
      "click": _vm.deleteRemark
    }
  }, [_vm._v(_vm._s(this.$t('action_message.remove')))]) : _vm._e(), _vm._v(" "), (_vm.enableEditMode) ? _c('button', {
    staticClass: "btn btn-store btn-lg float-right btn-space",
    on: {
      "click": _vm.gotoEditMode
    }
  }, [_vm._v(_vm._s(this.$t('action_message.edit')))]) : _vm._e(), _vm._v(" "), (_vm.mode === _vm.MODE_NORMAL) ? _c('button', {
    staticClass: "btn btn-store btn-lg float-right btn-space",
    on: {
      "click": _vm.gotoNewMode
    }
  }, [_vm._v(_vm._s(this.$t('action_message.add')))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20f525a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RemarkEditor.vue
// module id = 987
// module chunks = 1